import Store from "App/Store.js";
import dOrg from "Dispatchers/dOrg.js";

export default () => {
	const state = Store.getState();
	const org = (!state?.authAdmin?.token ? state?.auth?.orgs : state?.authAdmin?.orgs)?.[0];
	const orgCurrent = (!state?.authAdmin?.token ? state?.org : state?.orgAdmin);
	if (org && !orgCurrent) dOrg(org.Id);
};
